<main class="main trp-grid__container trp-flex--column" resizeDetector>
	@if ((showAppLoader$ | async) === true) {
		<cm-loader></cm-loader>
	}
	<router-outlet></router-outlet>
</main>
